import React from 'react';
import { PeopleIcon, CalcIcon, SettingsIcon, FinishIcon, ChartIcon, ShareIcon } from '../icons/Icons';

export default function Header({ activeTab, onTabChange, onFinishBanya, onShare, banyaExists, banya }) {

  if (!banyaExists) {
    return (
      <header className="header header--centered">
        <div className="header-left">
          <span className="header-logo">Банькулятор</span>
        </div>
      </header>
    );
  }

  return (
    <header className="header">
      <div className="header-left">
        <span className="header-logo">Банькулятор</span>
      </div>
      <nav className="header-nav">
        <button className={activeTab === 'people' ? 'active' : ''} onClick={() => onTabChange('people')}>
          <PeopleIcon color={activeTab === 'people' ? '#000000' : '#bbbbbb'} />
        </button>
        <button className={activeTab === 'calc' ? 'active' : ''} onClick={() => onTabChange('calc')}>
          <CalcIcon color={activeTab === 'calc' ? '#000000' : '#bbbbbb'} />
        </button>
        <button className={activeTab === 'stats' ? 'active' : ''} onClick={() => onTabChange('stats')}>
          <ChartIcon color={activeTab === 'stats' ? '#000000' : '#bbbbbb'} />
        </button>
        <button className={activeTab === 'settings' ? 'active' : ''} onClick={() => onTabChange('settings')}>
          <SettingsIcon color={activeTab === 'settings' ? '#000000' : '#bbbbbb'} />
        </button>
        <button onClick={onShare} title="Поделиться">
          <ShareIcon color="#bbbbbb" />
        </button>
        <button onClick={onFinishBanya}>
          <FinishIcon />
        </button>
      </nav>
    </header>
  );
}
